export const GOOGLE_MERCHANT_ID = process.env.REACT_APP_GOOGLE_MERCHANT_ID;
if (GOOGLE_MERCHANT_ID === undefined) {
  console.error('Google MerchantID is not set');
}
